import { render } from "./ProductBasePriceExTank.html?vue&type=template&id=5005ca87&scoped=true"
import script from "./ProductBasePriceExTank.js?vue&type=script&lang=js"
export * from "./ProductBasePriceExTank.js?vue&type=script&lang=js"

import "./ProductBasePriceExTank.css?vue&type=style&index=0&id=5005ca87&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5005ca87"]])

export default __exports__